export const STAKE_ABI = [
  {
    inputs: [
      { internalType: "address", name: "uvm_token", type: "address" },
      { internalType: "address", name: "dnm_token", type: "address" },
      { internalType: "address", name: "land_token_wrapper", type: "address" },
      { internalType: "uint256", name: "launch_time", type: "uint256" },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  { inputs: [], name: "OnlyDao", type: "error" },
  { inputs: [], name: "OnlyOnce", type: "error" },
  {
    inputs: [{ internalType: "address", name: "owner", type: "address" }],
    name: "OwnableInvalidOwner",
    type: "error",
  },
  {
    inputs: [{ internalType: "address", name: "account", type: "address" }],
    name: "OwnableUnauthorizedAccount",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "user", type: "address" },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "AddTokenToPool",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "user_id",
        type: "uint256",
      },
      { indexed: false, internalType: "uint8", name: "plan", type: "uint8" },
      {
        indexed: false,
        internalType: "uint256",
        name: "dnmAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "uvm_amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "land_id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "stake_id",
        type: "uint256",
      },
    ],
    name: "NewStake",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user_address",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "user_id",
        type: "uint256",
      },
    ],
    name: "NewUser",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "to", type: "address" },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "TransferReward",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "user", type: "address" },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Withdraw",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "stake_id",
        type: "uint256",
      },
    ],
    name: "WithdrawUserStake",
    type: "event",
  },
  {
    inputs: [],
    name: "DNM_TOKEN",
    outputs: [{ internalType: "contract ERC20", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "EIGHTEEN_MONTH_DURATION",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "FEE_PERCENT",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "LAND_TOKEN",
    outputs: [{ internalType: "contract IWrapper", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "LAUNCH_TIME",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ONE_YEAR_DURATION",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "REWARD_DECAY_FACTOR",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "REWARD_DECAY_PERIOD",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "STAKE_LIST_ID",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "STAKE_MAX_DNM",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "STAKE_MAX_UVM",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "STAKE_MIN_DNM",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "TIME_STEP",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "TOP_UP_PHASE",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "TOTAL_DNM_STAKED",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "TOTAL_LAND_STAKED",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "TOTAL_REWARD",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "TOTAL_UVM_STAKED",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "TWO_YEAR_DURATION",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "USER_LIST_ID",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "UVM_FEE_BALANCE",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "UVM_POOL_BALANCE",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "UVM_TOKEN",
    outputs: [{ internalType: "contract ERC20", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "amount", type: "uint256" }],
    name: "addTokenToPool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint8", name: "plan", type: "uint8" }],
    name: "allowedDnmAmountStake",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "dnm", type: "uint256" }],
    name: "calDnmUvmRatio",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint16", name: "plan_type", type: "uint16" },
      { internalType: "uint256", name: "dnm_amount", type: "uint256" },
      { internalType: "uint256", name: "start", type: "uint256" },
      { internalType: "uint256", name: "end", type: "uint256" },
      { internalType: "uint256", name: "stake_duration", type: "uint256" },
    ],
    name: "calculateReward",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "stake_id", type: "uint256" }],
    name: "calculateRewardForStake",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "dao",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getActiveStake",
    outputs: [
      {
        components: [
          { internalType: "uint256", name: "userId", type: "uint256" },
          { internalType: "bool", name: "exists", type: "bool" },
          { internalType: "uint8", name: "plan", type: "uint8" },
          { internalType: "uint256", name: "uvm", type: "uint256" },
          { internalType: "uint256", name: "dnm", type: "uint256" },
          { internalType: "uint256", name: "land", type: "uint256" },
          { internalType: "uint256", name: "start", type: "uint256" },
          { internalType: "uint256", name: "finish", type: "uint256" },
          { internalType: "uint256", name: "stake_duration", type: "uint256" },
          { internalType: "uint256", name: "total_paid_out", type: "uint256" },
        ],
        internalType: "struct StakeMeta.StakePlan[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getAllStake",
    outputs: [
      {
        components: [
          { internalType: "uint256", name: "userId", type: "uint256" },
          { internalType: "bool", name: "exists", type: "bool" },
          { internalType: "uint8", name: "plan", type: "uint8" },
          { internalType: "uint256", name: "uvm", type: "uint256" },
          { internalType: "uint256", name: "dnm", type: "uint256" },
          { internalType: "uint256", name: "land", type: "uint256" },
          { internalType: "uint256", name: "start", type: "uint256" },
          { internalType: "uint256", name: "finish", type: "uint256" },
          { internalType: "uint256", name: "stake_duration", type: "uint256" },
          { internalType: "uint256", name: "total_paid_out", type: "uint256" },
        ],
        internalType: "struct StakeMeta.StakePlan[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getContractDNMBalance",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getContractUVMBalance",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getFinishedStake",
    outputs: [
      {
        components: [
          { internalType: "uint256", name: "userId", type: "uint256" },
          { internalType: "bool", name: "exists", type: "bool" },
          { internalType: "uint8", name: "plan", type: "uint8" },
          { internalType: "uint256", name: "uvm", type: "uint256" },
          { internalType: "uint256", name: "dnm", type: "uint256" },
          { internalType: "uint256", name: "land", type: "uint256" },
          { internalType: "uint256", name: "start", type: "uint256" },
          { internalType: "uint256", name: "finish", type: "uint256" },
          { internalType: "uint256", name: "stake_duration", type: "uint256" },
          { internalType: "uint256", name: "total_paid_out", type: "uint256" },
        ],
        internalType: "struct StakeMeta.StakePlan[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "land_id", type: "uint256" }],
    name: "getPlanByTokenId",
    outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "id", type: "uint256" }],
    name: "getStake",
    outputs: [
      {
        components: [
          { internalType: "uint256", name: "userId", type: "uint256" },
          { internalType: "bool", name: "exists", type: "bool" },
          { internalType: "uint8", name: "plan", type: "uint8" },
          { internalType: "uint256", name: "uvm", type: "uint256" },
          { internalType: "uint256", name: "dnm", type: "uint256" },
          { internalType: "uint256", name: "land", type: "uint256" },
          { internalType: "uint256", name: "start", type: "uint256" },
          { internalType: "uint256", name: "finish", type: "uint256" },
          { internalType: "uint256", name: "stake_duration", type: "uint256" },
          { internalType: "uint256", name: "total_paid_out", type: "uint256" },
        ],
        internalType: "struct StakeMeta.StakePlan",
        name: "sp",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "user_address", type: "address" },
    ],
    name: "getUser",
    outputs: [
      { internalType: "uint256", name: "", type: "uint256" },
      { internalType: "bool", name: "", type: "bool" },
      { internalType: "uint256", name: "", type: "uint256" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "user_address", type: "address" },
    ],
    name: "getUserStake",
    outputs: [
      {
        components: [
          { internalType: "uint256", name: "userId", type: "uint256" },
          { internalType: "bool", name: "exists", type: "bool" },
          { internalType: "uint8", name: "plan", type: "uint8" },
          { internalType: "uint256", name: "uvm", type: "uint256" },
          { internalType: "uint256", name: "dnm", type: "uint256" },
          { internalType: "uint256", name: "land", type: "uint256" },
          { internalType: "uint256", name: "start", type: "uint256" },
          { internalType: "uint256", name: "finish", type: "uint256" },
          { internalType: "uint256", name: "stake_duration", type: "uint256" },
          { internalType: "uint256", name: "total_paid_out", type: "uint256" },
        ],
        internalType: "struct StakeMeta.StakePlan[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "user_address", type: "address" },
    ],
    name: "getUserStakeIds",
    outputs: [{ internalType: "uint256[]", name: "", type: "uint256[]" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "_dao", type: "address" }],
    name: "setDao",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "_fee_percent", type: "uint256" },
    ],
    name: "setFeePercent",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "dnmAmount", type: "uint256" },
      { internalType: "uint256", name: "land_id", type: "uint256" },
      { internalType: "uint256", name: "stake_duration", type: "uint256" },
    ],
    name: "stake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "staker", type: "address" },
      { internalType: "uint256", name: "dnmAmount", type: "uint256" },
      { internalType: "uint256", name: "land_id", type: "uint256" },
      { internalType: "uint256", name: "stake_duration", type: "uint256" },
    ],
    name: "stakeFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    name: "stakeList",
    outputs: [
      { internalType: "uint256", name: "userId", type: "uint256" },
      { internalType: "bool", name: "exists", type: "bool" },
      { internalType: "uint8", name: "plan", type: "uint8" },
      { internalType: "uint256", name: "uvm", type: "uint256" },
      { internalType: "uint256", name: "dnm", type: "uint256" },
      { internalType: "uint256", name: "land", type: "uint256" },
      { internalType: "uint256", name: "start", type: "uint256" },
      { internalType: "uint256", name: "finish", type: "uint256" },
      { internalType: "uint256", name: "stake_duration", type: "uint256" },
      { internalType: "uint256", name: "total_paid_out", type: "uint256" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "updateTopUp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    name: "userList",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          { internalType: "uint256", name: "userId", type: "uint256" },
          { internalType: "bool", name: "exists", type: "bool" },
          { internalType: "uint8", name: "plan", type: "uint8" },
          { internalType: "uint256", name: "uvm", type: "uint256" },
          { internalType: "uint256", name: "dnm", type: "uint256" },
          { internalType: "uint256", name: "land", type: "uint256" },
          { internalType: "uint256", name: "start", type: "uint256" },
          { internalType: "uint256", name: "finish", type: "uint256" },
          { internalType: "uint256", name: "stake_duration", type: "uint256" },
          { internalType: "uint256", name: "total_paid_out", type: "uint256" },
        ],
        internalType: "struct StakeMeta.StakePlan",
        name: "sp",
        type: "tuple",
      },
    ],
    name: "withdrawAllowance",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "amount", type: "uint256" },
      { internalType: "address", name: "to", type: "address" },
    ],
    name: "withdrawFeeByDao",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "stake_id", type: "uint256" }],
    name: "withdrawReward",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "stake_id", type: "uint256" },
      { internalType: "bool", name: "withdraw_reward", type: "bool" },
    ],
    name: "withdrawStake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;
